import * as DialogPrimitive from '@radix-ui/react-dialog'

import { useNearestShadowContainer } from '@/hooks/useNearestShadowContainer'

type DialogPortalProps = {
  children: React.ReactNode
}

/**
 * This component wraps Radix's Portal implementation to handle SSR issues
 * as well as portalling to the wrong body element when rendering in an iframe.
 */
export function DialogPortal(props: DialogPortalProps) {
  const { children } = props
  const { anchorRef, container } = useNearestShadowContainer()

  return (
    <>
      <span className="hidden" ref={anchorRef} />

      <DialogPrimitive.Portal
        container={container}
        forceMount
      >
        {children}
      </DialogPrimitive.Portal>
    </>
  )
}
